let colores: { [clave: string]: string } = {
  ANULADO: 'rgb(255, 58, 58)',
  VIGENTE: '#26FF26',
  FINALIZADO: '#C0C0C0',
};
export const campos = [
  {
    headerName: 'Número',
    field: 'devonumero',
    width: 120,
  },
  {
    headerName: 'Fecha Recepción',
    field: 'devofecha_recepcion',
  },
  {
    headerName: 'Fecha de Registro',
    field: 'devofecha_alta',
  },
  {
    headerName: 'Requerimiento',
    field: 'devorequerimiento',
  },
  {
    headerName: 'Coordinador',
    field: 'coorname',
    width: 250,
  },
  {
    headerName: 'Estado',
    field: 'devoanuladesc',
    cellRenderer: (params: any) => {
      return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
        colores[params.data.devoanuladesc]
      }"></i>
        <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">
        ${params.data.devoanuladesc}
        </a>
        `;
    },
  },
  {
    headerName: 'Serie Número',
    field: 'serienumero',
  },
  {
    headerName: 'Equipo',
    field: 'tipoeqname',
    width: 250,
  },
  {
    headerName: 'Registrada en Plataforma',
    field: 'registrada',
  },
  {
    headerName: 'Número de SIM',
    field: 'simserienumero',
  },
  {
    headerName: 'Estado de SIM',
    field: 'configvalor',
  },
];
